export function parseWhitelistText(text) {
  return Array.from(new Set(
    String(text || '')
      .split(/\r?\n/)
      .map((item) => item.trim())
      .filter(Boolean)
  ));
}

export function whitelistToText(whitelist) {
  const ips = Array.isArray(whitelist?.ips) ? whitelist.ips : [];
  return ips.join('\n');
}

export function whitelistStateText(whitelist) {
  return whitelist?.enabled === true ? '已开启' : '未开启';
}

export function buildAccessLogParams(form) {
  const params = {};
  const username = String(form?.username || '').trim();
  const ip = String(form?.ip || '').trim();
  const eventType = String(form?.eventType || '').trim();
  const limit = Number(form?.limit || 100);

  if (username) params.username = username;
  if (ip) params.ip = ip;
  if (eventType) params.eventType = eventType;
  params.limit = Number.isFinite(limit) ? Math.max(1, Math.min(500, limit)) : 100;
  return params;
}
